// Action types
export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const UPDATE_TOTAL_PRICE = 'UPDATE_TOTAL_PRICE';

// Action creators
export const addItem = (item) => ({
  type: ADD_ITEM,
  payload: item,
});

export const removeItem = (item) => ({
  type: REMOVE_ITEM,
  payload: item,
});

export const updateTotalPrice = (totalPrice) => ({
  type: UPDATE_TOTAL_PRICE,
  payload: totalPrice,
});
